import axiosInstance from '../../AxiosInstance/axiosinstance';

export const toggleSidebar = () => ({
    type: 'TOGGLE_SIDEBAR',
  });
  